"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILActiveCourseList = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var il_active_course_card_1 = require("../il-active-course-card/il-active-course-card");
var typeography_common_1 = require("../typeography/typeography.common");
function ILActiveCourseList(_a) {
    var courses = _a.courses, title = _a.title, showLeftIndicator = _a.showLeftIndicator, showRightIndicator = _a.showRightIndicator, sx = _a.sx, className = _a.className, selectedCourse = _a.selectedCourse, _b = _a.emptyMessage, emptyMessage = _b === void 0 ? 'No active courses' : _b, children = _a.children, props = __rest(_a, ["courses", "title", "showLeftIndicator", "showRightIndicator", "sx", "className", "selectedCourse", "emptyMessage", "children"]);
    var hasLeftIndicatorSelected = showLeftIndicator && selectedCourse && (courses === null || courses === void 0 ? void 0 : courses.some(function (c) { return c.key === (selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.key); }));
    var hasCourses = courses && courses.length > 0;
    function onClick(value) {
        props.onClick && props.onClick(value);
    }
    return (react_1.default.createElement(material_1.Box, { className: 'il-active-couse-list ' + className, sx: __assign({ display: 'flex', flexDirection: 'column', height: '100%' }, sx) },
        title && (react_1.default.createElement(typeography_common_1.ILH6, { sx: {
                color: 'text.secondary',
                fontSize: '0.9375rem',
                fontWeight: 'bold',
                mb: '1rem',
                px: '0.5rem',
                ml: hasLeftIndicatorSelected ? '2rem' : 0,
            } }, title)),
        !hasCourses && (react_1.default.createElement(typeography_common_1.ILBody1, { sx: { color: 'text.secondary', px: '0.5rem' } }, emptyMessage)),
        hasCourses &&
            courses.map(function (course, idx) {
                var isCourseSelected = course.key === (selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.key);
                return (react_1.default.createElement(material_1.Box, { key: course.courseName + idx, sx: __assign(__assign({ display: 'flex', flexDirection: 'row', alignItems: 'center' }, (!isCourseSelected &&
                        hasLeftIndicatorSelected && {
                        ml: '2rem',
                    })), { '& .MuiCard-root': __assign({ my: '0.125rem' }, (isCourseSelected && {
                            borderColor: 'primary.dark',
                            borderWidth: '0.125rem',
                            borderStyle: 'solid',
                        })), '& .MuiCard-root:hover': {
                            borderColor: 'primary.dark',
                            cursor: 'pointer',
                        } }), onClick: function () { return onClick(course); } },
                    showLeftIndicator && isCourseSelected && (react_1.default.createElement(material_1.Box, { sx: {
                            borderWidth: '2rem 0 2rem 2rem',
                            borderStyle: 'solid',
                            borderColor: 'transparent',
                            borderLeftColor: 'background.default',
                        } })),
                    react_1.default.createElement(il_active_course_card_1.IlActiveCourseCard, { customIconType: course.customIconType, courseName: course.courseName, assignmentName: course.assignmentName, startDate: course.startDate, endDate: course.endDate, weekdaySelections: course.weekdaySelections }),
                    showRightIndicator && isCourseSelected && (react_1.default.createElement(material_1.Box, { sx: {
                            borderWidth: '2rem 2rem 2rem 0',
                            borderStyle: 'solid',
                            borderColor: 'transparent',
                            borderRightColor: 'background.default',
                        } }))));
            }),
        children));
}
exports.ILActiveCourseList = ILActiveCourseList;
